import FeatureGates from '@atlaskit/feature-gate-js-client';

export const useIsNav4Enabled = () => {
	const isProductEnabled = FeatureGates.checkGate('confluence_nav_4');

	return isProductEnabled;
};
